import { get, set, expire, enabled } from 'cookies-js';

function isEnabled() {
  if (typeof document === 'undefined') {
    // running in server context
    return false;
  }

  return enabled;
}

export default {
  isEnabled,
  get,
  set,
  expire,
};
